<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Doenças crônicas"
            description="Acompanhamento integral portadores"
            url="/esf-eap"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import AtendimentosDiabetes from '@/components/icons/IndicadoresAps/DoencasCronicas/AtendimentosDiabetes.vue'
import HiperDia from '@/components/icons/IndicadoresAps/DoencasCronicas/HiperDia.vue'
import AtendimentoHipertensao from '@/components/icons/IndicadoresAps/DoencasCronicas/AtendimentoHipertensao.vue'

export default {
  name: 'DoencasCronicas',
  components: {
    Menu,
    Footer,
    SectionTitle,
    AtendimentosDiabetes,
    HiperDia,
    AtendimentoHipertensao,
  },
  computed: {
    cards() {
      return this.$store.state?.permissoes?.doencas_cronicas
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
